export default function (Component) {
Component.options.__docs = "<p>This shows a composition of four <code>FdTime</code> components to create a TimeItem. If this is the plan, it is suggested to use the TimeItem component instead. </p>\n"
}